/**
 * Report-Definition für die Arbeitspakete-Liste.
 *
 * Übersetzt den geladenen Datenstand in ein {@link ReportDocument}. Analog zu
 * {@link ./projektauftragReport}: deklariert nur den Inhalt, der gemeinsame
 * Renderer erzeugt das PDF.
 */
import {
  buildDocument,
  tableBlock,
  type ReportBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface ArbeitspaketeReportItem {
  nr: string;
  titel: string | null;
  status: string;
  start_date: string | null;
  end_date: string | null;
  story_points: number | null;
  progress: number;
}

export interface ArbeitspaketeReportInput {
  items: ArbeitspaketeReportItem[];
}

/** 'YYYY-MM-DD' -> 'DD.MM.YYYY'; leere/ungültige Werte -> ''. */
function formatDate(iso: string | null): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

export function buildArbeitspaketeReport(input: ArbeitspaketeReportInput): ReportDocument {
  const block: ReportBlock =
    input.items.length > 0
      ? tableBlock(
          [
            { header: 'Nr', weight: 0.9 },
            { header: 'Titel', weight: 2.8 },
            { header: 'Status', weight: 1.3 },
            { header: 'Start', weight: 1.2 },
            { header: 'Ende', weight: 1.2 },
            { header: 'SP', weight: 0.7 },
            { header: 'Fortschritt', weight: 1.1 },
          ],
          input.items.map((ap) => [
            ap.nr || '—',
            ap.titel || '—',
            ap.status || '—',
            formatDate(ap.start_date) || '—',
            formatDate(ap.end_date) || '—',
            ap.story_points != null ? String(ap.story_points) : '—',
            `${ap.progress}%`,
          ]),
        )!
      : { kind: 'note', value: 'Noch keine Arbeitspakete erfasst.' };

  return buildDocument([{ title: 'Arbeitspakete', blocks: [block] }]);
}
